import ClientsInfoPage from './components/ClientsInfoPage.vue';

export default {
  routes: [
    {
      path: '/',
      component: ClientsInfoPage,
      name: 'clientsInfo',
    },
  ],
};
